export default class CandidateExportForm {
  companyId = 0;
  async = 0;
  submitTimeStart = "";
  submitTimeStop = "";
}
